<script lang="ts">
    import { operationSumEndcustomerPrice } from "../../../../functions/operations/operationSumEndcustomerPrice"
    import { normalizeVat } from "../../../../../../api/hooks/config-client"
    import { _ } from "svelte-i18n"

    export let operation: OperationOut

    let positionCount: number = 0
    let total: number = 0

    $: if (operation) {
        ;[operation, positionCount, total] = operationSumEndcustomerPrice(operation)
    }
</script>

{#if operation}
    <div class=" operation-summary">
        <div class="inner-container">
            <div class="">
                <div class="no-padding-top no-padding-bottom w-380 double-line"></div>
            </div>
            <div class="lowerwrf no-border-top">
                <div class="middle w-80" style="flex: 1; ">{positionCount}</div>
                <div class="middle w-200" style="width: 250px; text-align: left;">
                    {total.toFixed(2)} € &nbsp;
                    <small
                        >({$_("components.pcalcGroup.inclusive")}
                        {normalizeVat(operation.endCustomerVAT)}% {$_("components.pcalcGroup.vat")})</small
                    >
                </div>
            </div>
        </div>
    </div>
{/if}
